if (!customElements.get('faq-section')) {
  class FaqSection extends HTMLElement {
    connectedCallback() {
      this.details = Array.from(this.querySelectorAll('.faq-page__item'));
      this.navLinks = Array.from(this.querySelectorAll('.faq-page__nav-link'));
      this.categories = Array.from(this.querySelectorAll('.faq-page__category'));

      this.details.forEach((detail) => {
        detail.addEventListener('toggle', () => this.handleToggle(detail));
      });

      this.navLinks.forEach((link) => {
        link.addEventListener('click', () => {
          const target = this.querySelector(`#${CSS.escape(link.dataset.faqTarget)}`);
          if (target) target.scrollIntoView({ behavior: this.prefersReducedMotion() ? 'auto' : 'smooth', block: 'start' });
        });
      });

      if ('IntersectionObserver' in window && this.categories.length) {
        this.observer = new IntersectionObserver((entries) => this.updateActiveLink(entries), {
          rootMargin: '-20% 0px -65% 0px',
          threshold: 0
        });
        this.categories.forEach((category) => this.observer.observe(category));
      }
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    handleToggle(activeDetail) {
      const summary = activeDetail.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', activeDetail.open ? 'true' : 'false');
      if (!activeDetail.open) return;

      this.details.forEach((detail) => {
        if (detail !== activeDetail && detail.open) detail.removeAttribute('open');
      });
    }

    updateActiveLink(entries) {
      const visible = entries
        .filter((entry) => entry.isIntersecting)
        .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top)[0];
      if (!visible) return;

      this.navLinks.forEach((link) => {
        const active = link.dataset.faqTarget === visible.target.id;
        link.classList.toggle('is-active', active);
        if (active) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      });
    }

    prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }
  }

  customElements.define('faq-section', FaqSection);
}
